<app-button (clicked)="activate()"
            [appButtonType]="AppButtonType"
            [buttonText]="description() | translate"
            [qaTag]="dataQa() + '-button'"
            [svgIcon]="svgIcon()"
            class="action-item-button"/>
